import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import NoSamplesMessageEN from 'components/Content/FreeSamples/NoSamplesMessage/locales/NoSamplesMessage_en_US.js';
import NoSamplesMessageFR from 'components/Content/FreeSamples/NoSamplesMessage/locales/NoSamplesMessage_fr_CA.js';

const { getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(NoSamplesMessageEN, NoSamplesMessageFR);

const NoSamplesMessage = () => {
    return <p role='status'>{getText('noSamplesInStock')}</p>;
};

export default wrapFunctionalComponent(NoSamplesMessage, 'NoSamplesMessage');
